import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-create",
  "use": "icon-create-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-create\"><defs><style type=\"text/css\"></style></defs><path d=\"M475.428571 475.428571V292.571429h73.142858v182.857142h182.857142v73.142858h-182.857142v182.857142h-73.142858v-182.857142H292.571429v-73.142858h182.857142zM146.285714 73.142857h731.428572a73.142857 73.142857 0 0 1 73.142857 73.142857v731.428572a73.142857 73.142857 0 0 1-73.142857 73.142857H146.285714a73.142857 73.142857 0 0 1-73.142857-73.142857V146.285714a73.142857 73.142857 0 0 1 73.142857-73.142857z m0 73.142857v731.428572h731.428572V146.285714H146.285714z\" p-id=\"18721\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/create.svg
// module id = 49zR
// module chunks = 80